<div class="img-div">
  <img class="img" src="assets/img/reelax-black-logo.svg">
</div>
<div class="text">
  {{ 'serverFallback.requireJavascript' | transloco }}
</div>